import { type Observable } from 'rxjs';

import { type WorkflowNodeBase } from '@blaze-shared/workflow-domain';

import { type NodeExecutionInput } from './node-execution-input';
import { type NodeExecutionResult } from './node-execution-result';

export abstract class NodeExecutionService<T extends WorkflowNodeBase> {
  constructor(protected readonly node: T) {}

  execute(input: NodeExecutionInput): Observable<NodeExecutionResult | undefined> {
    this.validate(input);
    return this.handle(input);
  }

  /**
   * This method is called to execute the node.
   * @returns an observable that emits the result of the execution.
   * `undefined` means default behavior - pass the data through and go to the next node.
   */
  protected abstract handle(input: NodeExecutionInput): Observable<NodeExecutionResult | undefined>;
  /**
   * This method throws if the input or node configuration is invalid.
   */
  protected abstract validate(input: NodeExecutionInput): void;
}
